import { HisSelectOperatorType } from './his-select-operator-type';
import { HisWidgetBase } from './his-widget-base';

/**
 * Class to hold values of {@link HisSelectOperatorType} and {@code widget.kind}
 * to use as params at the {@link HisSearchService.setOperator( operatorTrigger: HisOperatorTrigger )}
 */
export class HisOperatorTrigger {

    operator: HisSelectOperatorType;
    widget: HisWidgetBase<any>;

    constructor( operator: HisSelectOperatorType, widget: HisWidgetBase<any> ) {
        this.operator = operator;
        this.widget = widget;
    }

    public getOperator(): HisSelectOperatorType {
        return this.operator;
    }

    public getWidget(): HisWidgetBase<any> {
        return this.widget;
    }

}
